/* ==========================================
   SINGLES PAGE
========================================== */

function initSinglesPage() {

  const page =
    document.querySelector(
      "[data-singles-page]"
    );


  if (!page) {
    return;
  }


  if (
    page.dataset.singlesInitialized ===
    "true"
  ) {
    return;
  }


  const select =
    page.querySelector(
      "[data-single-select]"
    );


  const list =
    page.querySelector(
      "[data-singles-list]"
    );


  const singles =
    Array.from(
      page.querySelectorAll(
        ".single-release"
      )
    );


  if (
    !select ||
    singles.length === 0
  ) {
    return;
  }


  page.dataset.singlesInitialized =
    "true";


  /* ========================================
     DATE HELPERS
  ======================================== */

  function getDateValue(
    value
  ) {

    if (!value) {
      return 0;
    }


    const timestamp =
      Date.parse(
        value
      );


    return Number.isNaN(
      timestamp
    )
      ? 0
      : timestamp;

  }


  /* ========================================
     SORT NEWEST → OLDEST
  ======================================== */

  function sortSingles() {

    /*
      Sort release articles.
    */

    singles.sort(
      (a, b) => {

        return (
          getDateValue(
            b.dataset.singleDate
          ) -
          getDateValue(
            a.dataset.singleDate
          )
        );

      }
    );


    singles.forEach(
      (single) => {

        list?.appendChild(
          single
        );

      }
    );


    /*
      Sort dropdown options using
      the same release-date order.
    */

    const options =
      Array.from(
        select.options
      );


    options.sort(
      (a, b) => {

        return (
          getDateValue(
            b.dataset.singleDate
          ) -
          getDateValue(
            a.dataset.singleDate
          )
        );

      }
    );


    options.forEach(
      (option) => {

        select.appendChild(
          option
        );

      }
    );

  }


  /* ========================================
     URL
  ======================================== */

  function getRequestedSingle() {

    const params =
      new URLSearchParams(
        window.location.search
      );


    return params.get(
      "single"
    );

  }


  function updateURL(
    singleId
  ) {

    const url =
      new URL(
        window.location.href
      );


    url.searchParams.set(
      "single",
      singleId
    );


    window.history.replaceState(
      {},
      "",
      url
    );

  }


  /* ========================================
     FIND SINGLE
  ======================================== */

  function findSingle(
    singleId
  ) {

    return singles.find(
      (single) =>
        single.dataset.singleId ===
        singleId
    );

  }


  /* ========================================
     STREAMING
  ======================================== */

  function updateStreaming(
    selectedSingle
  ) {

    const streamingData = {

      type:
        "single",


      spotify: {

        id:
          selectedSingle.dataset
            .spotifyId || "",

        link:
          selectedSingle.dataset
            .spotifyLink || ""

      },


      appleMusic: {

        embedUrl:
          selectedSingle.dataset
            .appleMusicEmbed || "",

        link:
          selectedSingle.dataset
            .appleMusicLink || ""

      },


      youtube: {

        id:
          selectedSingle.dataset
            .youtubeId || "",

        link:
          selectedSingle.dataset
            .youtubeLink || ""

      },


      soundcloud: {

        url:
          selectedSingle.dataset
            .soundcloudUrl || "",

        link:
          selectedSingle.dataset
            .soundcloudLink || ""

      }

    };


    /*
      release.js reads this on initial
      load and when the theme changes.
    */

    window.releaseStreamingData =
      streamingData;


    /*
      If release.js is already loaded,
      update immediately.
    */

    if (
      typeof window
        .updateReleaseStreaming ===
      "function"
    ) {

      window.updateReleaseStreaming(
        streamingData
      );

    }


    /*
      If release.js initializes later,
      it can also receive this event.
    */

    document.dispatchEvent(
      new CustomEvent(
        "streaming:data",
        {
          detail:
            streamingData
        }
      )
    );

  }


  /* ========================================
     DISPLAY SINGLE
  ======================================== */

  function selectSingle(
    singleId
  ) {

    const selectedSingle =
      findSingle(
        singleId
      );


    if (!selectedSingle) {
      return null;
    }


    singles.forEach(
      (single) => {

        single.classList.toggle(
          "active",
          single ===
            selectedSingle
        );

      }
    );


    select.value =
      singleId;


    updateStreaming(
      selectedSingle
    );


    return selectedSingle;

  }


  /* ========================================
     INITIAL SETUP
  ======================================== */

  sortSingles();


  const requestedSingle =
    getRequestedSingle();


  const requestedExists =
    requestedSingle &&
    findSingle(
      requestedSingle
    );


  /*
    If URL contains a valid handle,
    use that.

    Otherwise use the newest release,
    which is now the first item after
    date sorting.
  */

  const initialSingle =
    requestedExists
      ? requestedSingle
      : singles[0]
          ?.dataset
          .singleId;


  if (initialSingle) {

    selectSingle(
      initialSingle
    );

  }


  /* ========================================
     DROPDOWN
  ======================================== */

  select.addEventListener(
    "change",
    () => {

      const selectedSingle =
        selectSingle(
          select.value
        );


      if (!selectedSingle) {
        return;
      }


      updateURL(
        select.value
      );

    }
  );


  /* ========================================
     BACK / FORWARD
  ======================================== */

  window.addEventListener(
    "popstate",
    () => {

      const requested =
        getRequestedSingle();


      if (
        requested &&
        findSingle(
          requested
        )
      ) {

        selectSingle(
          requested
        );

      }

    }
  );

}


/* ==========================================
   PAGE LOAD
========================================== */

document.addEventListener(
  "DOMContentLoaded",
  initSinglesPage
);


/* ==========================================
   SHOPIFY THEME EDITOR
========================================== */

document.addEventListener(
  "shopify:section:load",
  initSinglesPage
);


/*
  Also initialize immediately in case
  the script runs after DOMContentLoaded.
*/

initSinglesPage();